import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalPenuh extends React.Component {
    render() {
        const { showModalPenuh, cancelHandler, DeleteHandler2, Model, Model2, List, janjiHandler, createHandler, data } = this.props

        return (
            <div>
                
                <Modal show={showModalPenuh} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>CEK KETERSEDIAAN JADWAL</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Mohon maaf, waktu kedatangan yang anda pilih sudah terisi penuh.
                            Silahkan pilih waktu kedatangan yang lain <br /> <br />
                        </p>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler}>Batal</button>
                        <button class="btn btn-danger" onClick={()=>{janjiHandler(Model2.doctor_office_id)}}>Pilih Jadwal Lain </button>                        
                        {/* <button class="btn btn-danger" onClick={()=>{janjiHandler(data.id_doctor)}}>Pilih Jadwal Lain </button>                         */}
                        {/* <button class="btn btn-danger" onClick={()=>{editHandler(Model._id)}}>Pilih Jadwal Lain </button> */}
                        {/* <button type="button" class="btn btn-light" onClick={()=>{cancelHandler()}}>Batal</button> */}
                        

                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}